function Contact() {
  return (
    <section id="contato" className="contact">
        <div className="container contact-container">
        <div className="contact-info">
            <h2>Fale Conosco</h2>
            <p><strong>WhatsApp:</strong> <a href="https://wa.me/5519978291299" target="_blank" rel="noreferrer">(19) 97829-1299</a></p>
            <p><strong>Região:</strong> Pirassununga e Região</p>
            <p><strong>E-mail:</strong> <a href="mailto:contato@gmedlocacao.com.br">contato@gmedlocacao.com.br</a></p>
        </div>
        <div className="contact-form">
            <form onSubmit={(e) => {e.preventDefault(); alert('Formulário enviado!');}}>
                <label htmlFor="name">Nome</label>
                <input type="text" id="name" required />
                <label htmlFor="email">E-mail</label>
                <input type="email" id="email" required />
                <label htmlFor="whatsapp">WhatsApp</label>
                <input type="tel" id="whatsapp" required />
                <button type="submit">Enviar</button>
            </form>
        </div>
        </div>
    </section>
  );
}

export default Contact;
